import Handlebars from "handlebars";
import "#legacy/handlebars_helpers/background_color_helper.js";

(function (global) {
  global.componentContentTemplate = Handlebars.compile(
    '\
  {{#if componentIsLinked}}<a class="component-content component-content--linked" href={{link.url}}>{{else}}<div class="component-content">{{/if}}\
      <div class="component-content-backdrop" style="background-color: {{background}}"></div>\
      {{{output}}}\
  {{#if componentIsLinked}}</a>{{else}}</div>{{/if}}\
  ',
  );

  Handlebars.registerHelper("componentContent", function (options) {
    this.background = Handlebars.helpers.backgroundColor(this.content_background_color);
    this.output = options.fn(this);

    if (this.component_is_linked && this.link && this.link.url) {
      this.componentIsLinked = this;
    } else {
      this.componentIsLinked = false;
    }

    return new Handlebars.SafeString(global.componentContentTemplate(this));
  });
})(typeof window !== "undefined" ? window : this);
